import { render, staticRenderFns } from "./GuestNotificationModal.vue?vue&type=template&id=2c82b45a&scoped=true&"
import script from "./GuestNotificationModal.vue?vue&type=script&lang=js&"
export * from "./GuestNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./GuestNotificationModal.vue?vue&type=style&index=0&id=2c82b45a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c82b45a",
  null
  
)

export default component.exports